module.exports = __webpack_public_path__ + "5a4810e8bd6de2ebd2b636385739e453.png";